require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-the-local-project-melfort-residences.json") })
        }
      }, "path---journal-the-local-project-melfort-residences");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-the-local-project-melfort-residences!./.cache/json/journal-the-local-project-melfort-residences.json
// module id = 543
// module chunks = 231608221292675